export default {"src":"/_next/static/media/icon-arrow-bottom.2c8cf680.svg","height":32,"width":149,"blurWidth":0,"blurHeight":0};